import * as React from 'react';
import { Container, ThemeProvider } from '@mui/material';
import theme from '../theme';
import Header from './comps/Header';
import Description from './comps/Description';
import List from './comps/List';
import SubContent from './comps/SubContent';
import Footer from './comps/Footer';
import SubFooter from './comps/SubFooter';
import { ProjectCard } from '@manobin/ireno-generated-api';
import { Helmet } from 'react-helmet';

interface Meta {
  title: string;
  description: string;
}
interface Area {
  cover: string;
  title: string;
  description: string;
  meta_tags: Meta;
}

interface Props {
  pageContext: {
    projects: {
      popular: Array<ProjectCard>;
      new: Array<ProjectCard>;
    };
    area: Area;
  };
}
const AreaTemp: React.FC<Props> = ({ pageContext: { projects, area } }) => {
  React.useEffect(() => {
    document.title = area.title;
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>{area.meta_tags.title}</title>
        <meta name="description" content={area.meta_tags.description} />
      </Helmet>
      <Header cover={area.cover} title={area.title} />

      <Container>
        <Description>{area.description}</Description>

        <List items={projects.popular} type="Popular" label={area.title} />
        <List items={projects.new} type="Top" label={area.title} />
      </Container>
      <SubContent label={area.title} />

      <Footer />
      <SubFooter />
    </ThemeProvider>
  );
};

export default AreaTemp;
